import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import { LanguageProvider } from './i18n/LanguageContext';
import Header from './components/Header';
import HeroSection from './components/HeroSection';
import FeaturesSection from './components/FeaturesSection';
import CTASection from './components/CTASection';
import NewsletterSection from './components/NewsletterSection';
import Footer from './components/Footer';
import AboutPage from './pages/AboutPage';
import PrivacyPage from './pages/PrivacyPage';
import TermsPage from './pages/TermsPage';
import DeleteAccountPage from './pages/DeleteAccountPage';
import ContactPage from './pages/ContactPage';
import Share from './components/Share';

function HomePage() {
  return (
    <>
      <Header />
      <div className="min-h-screen bg-light-bg">
        <HeroSection />
        <CTASection />
        <FeaturesSection />
        <NewsletterSection />
      </div>
      <Footer />
    </>
  );
}

function App() {
  return (
    <LanguageProvider>
      <Router>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/about" element={<AboutPage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/delete-account" element={<DeleteAccountPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/share" element={<Share />} />
        </Routes>
      </Router>
    </LanguageProvider>
  );
}

export default App;
